import { RootState } from 'store';

export const selectJWTToken = (state: RootState) => state.token.jwToken;
export const selectAccessToken = (state: RootState) => state.token.authorization;
